import React from 'react'

const CallIcon = ({ color = '#999FAC' }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.625 18C14.8333 18 13.0869 17.6006 11.3858 16.8017C9.68417 16.0033 8.17722 14.9478 6.865 13.635C5.55222 12.3228 4.49667 10.8158 3.69833 9.11417C2.89944 7.41306 2.5 5.66667 2.5 3.875C2.5 3.625 2.58333 3.41667 2.75 3.25C2.91667 3.08333 3.125 3 3.375 3H6.75C6.94444 3 7.11806 3.0625 7.27083 3.1875C7.42361 3.3125 7.51389 3.47222 7.54167 3.66667L8.08333 6.58333C8.11111 6.77778 8.10778 6.95472 8.07333 7.11417C8.03833 7.27417 7.95833 7.41667 7.83333 7.54167L5.83333 9.58333C6.41667 10.5833 7.14583 11.5208 8.02083 12.3958C8.89583 13.2708 9.86111 14.0278 10.9167 14.6667L12.875 12.7083C13 12.5833 13.1633 12.4894 13.365 12.4267C13.5661 12.3644 13.7639 12.3472 13.9583 12.375L16.8333 12.9583C17.0278 13 17.1875 13.0936 17.3125 13.2392C17.4375 13.3853 17.5 13.5556 17.5 13.75V17.125C17.5 17.375 17.4167 17.5833 17.25 17.75C17.0833 17.9167 16.875 18 16.625 18Z"
        fill={color}
      />
    </svg>
  )
}

export default CallIcon

//url(#mask0_1262_32999)
